import { render, staticRenderFns } from "./SubscribedUsers.vue?vue&type=template&id=fd4f2028&"
import script from "./SubscribedUsers.vue?vue&type=script&lang=js&"
export * from "./SubscribedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports